import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { QueryRef } from "apollo-angular";
import { NgxSpinnerService } from "ngx-spinner";
import { BaseComponent } from "src/app/base/base.component";
import { ActionTasksService } from "src/app/service/action-tasks.service";
import { ActionService } from "src/app/service/action.service";
import {
  Action,
  ActionTask,
  CreateActionCommentActionInput,
  CreateActionTaskGQL,
  CreateActionTaskInput,
  RemoveActionTaskGQL,
  SearchActionInput,
  SearchActionQuery,
  UpdateActionTaskStatusGQL,
} from "src/generated/graphql";

@Component({
  selector: "app-actions-tasks",
  templateUrl: "./actions-tasks.component.html",
  styleUrls: ["./actions-tasks.component.scss"],
})
export class ActionsTasksComponent extends BaseComponent implements OnInit {
  tasksForm = new FormGroup({
    taskDescription: new FormControl("", [
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(255),
    ]),
  });

  actionId: string = "";
  tasks: ActionTask[];

  constructor(
    public router: Router,
    public route2: ActivatedRoute,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    private actionTasksService: ActionTasksService,
    private actionService: ActionService
  ) {
    super(router, loading, translate);
  }

  ngOnInit(): void {
    this.getParams();
    this.getAction();
  }

  getParams(): void {
    this.route2.params.subscribe((url: { id: string }) => {
      if (url?.id) {
        this.actionId = url.id;
      }
    });
  }

  onSubmit() {
    if (this.tasksForm.invalid) return;
    this.createTask(this.tasksForm.value.taskDescription);
  }

  getAction() {
    this.actionService.getActionById({ id: this.actionId }).subscribe({
      next: ({ action }) => {
        this.tasks = action.tasks;
      },
      error: (error) => this.onError(error),
    });
  }

  createTask(description: string) {
    const action: CreateActionCommentActionInput = { id: this.actionId };
    const input: CreateActionTaskInput = { action: action, description };

    this.actionTasksService.createActionTask({ input }).subscribe(
      ({ createActionTask }) => {
        this.tasks.unshift(createActionTask)
        this.showMessage('Sucesso', 'Tarefa criada com sucesso', 'success')
        this.tasksForm.reset();
      },
      (error) => super.onError(error)
    );
  }

  updateTaskStatus(taskId: string) {
    this.actionTasksService.updateActionTaskStatus({ id: taskId }).subscribe(
      ({ updateActionTaskStatus }) => {
        console.log("🚀 ~ updateActionTaskStatus:", updateActionTaskStatus);
        this.showMessage(
          "Sucesso",
          `Tarefa atualizada com sucesso`,
          "success"
        );
      },
      (err) => super.onError(err)
    );
  }

  removeActionTask(index: number, id: string) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente excluir essa tarefa?",
      () => {

        this.actionTasksService.removeActionTask({ id }).subscribe(
          () => {
            this.tasks.splice(index, 1);
            this.showMessage(
              "Sucesso",
              `Remoção realizada com sucesso`,
              "success"
            );
          },
          (err) => super.onError(err)
        );
      }
    );
  }
}
